import React, { ButtonHTMLAttributes, useRef, useEffect } from 'react';
import Icon from '../icon/icon.component';
import './modal.style.scss';

interface IModalProps extends ButtonHTMLAttributes<any> {
  title?: string;
  children?: any;
  width?: string;
  onClose: () => void;
  withoutPadding?: boolean;
}

const Modal = ({
  title,
  children,
  width = 'max-content',
  onClose,
  withoutPadding,
}: IModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="modal__overlay">
      <div ref={modalRef} className="modal__content" style={{ width }}>
        <div className="modal__header">
          <span>{title}</span>
          <button type="button" className="modal__close" onClick={onClose}>
            <Icon name="CircleX" />
          </button>
        </div>
        <div className="modal__body" style={withoutPadding ? { padding: 0 } : undefined}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
